import * as actionTypes from '../constants/actionTypes';
import * as pricingPages from '../constants/pricingPresets';
import {PRICING_PRESET_SET_RECEIVED} from "../constants/actionTypes";

export const AVAILABLE_PRICES = {
  "Retail": "Retail",
  "Cost": "Cost",
  "Discount": "Discount",
};

const initialState = {
  selectedPreset: {
    id: 0,
    type: 'stone',
    fabricatorId: 0,
    name: '',
    icon: '',
    isDefault: false,
    data: [],
    costData: [],
    discountData: [],
  },
  page: pricingPages.PRICING_PRESET_LIST,
  presets: false,
  show: false,
  assignPricingProfileShow: false,
  selected: {},
  assignPricingProfileStones: [],
  applyToPrice: AVAILABLE_PRICES.Retail,
  presetsReceived: true,
};

const fixInfinityEnd = (presets) => {
  for (let n = 0; n < presets.length; n++) {
    if (presets[n].end === null) {
      presets[n].end = Infinity;
    }
  }
}

const matchPropsObject = {
  "pricingPresetData": "data",
  "pricingPresetCostData": "costData",
  "pricingPresetDiscountData": "discountData",
}

function formatPresetData(preset) {
  if (!preset) {
    return {}
  }
  if (!preset["pricingPresetCostData"] && preset["pricingPresetData"]) {
    preset["pricingPresetCostData"] = preset["pricingPresetData"]; // set same as data, but different objects
  }
  if (!preset["pricingPresetDiscountData"] && preset["pricingPresetData"]) {
    preset["pricingPresetDiscountData"] = preset["pricingPresetData"]; // set same as data, but different objects
  }
  Object.keys(matchPropsObject).forEach(property => {
    const newPresetProperty = matchPropsObject[property];
    if (preset[property]) {
      preset[newPresetProperty] = JSON.parse(preset[property]);
      delete preset[property];
    }
    if (preset[newPresetProperty]) {
      fixInfinityEnd(preset[newPresetProperty]);
    }
  })
  return preset
}

export const getPresetUpdateProperty = (applyToPrice) => {
  return applyToPrice === AVAILABLE_PRICES.Cost
    ? "costData"
    : applyToPrice === AVAILABLE_PRICES.Discount
      ? "discountData"
      : "data"
}

export default function pricingPreset(state = initialState, action) {
  let newState = {...state};
  switch(action.type) {
    case actionTypes.PRICING_PRESET_SET_PRESETS:
      newState.presetsReceived = true;
      newState.presets = action.payload.presets.map(preset => {
        return formatPresetData(preset)
      });
      break;
    case actionTypes.PRICING_PRESET_SHOW:
      newState.page = action.payload.page;
      newState.show = action.payload.show;
      break;
    case actionTypes.PRICING_PRESET_ASSIGN_SHOW:
      newState.assignPricingProfileShow = action.payload.show;
      newState.assignPricingProfileStones = selectedSort({...newState.selected});
      break;
    case actionTypes.PRICING_PRESET_SET_SELECTED:
      newState.applyToPrice = AVAILABLE_PRICES.Retail; // show retail if it was changed to Cost in previous edit
      newState.selectedPreset = Object.assign({}, formatPresetData(action.payload.selectedPreset));
      break;
    case actionTypes.PRICING_PRESET_UPDATE_VALUE:
      const property = action.payload.field === "data"
        ? getPresetUpdateProperty(state.applyToPrice)
        : action.payload.field;
      return {...newState, selectedPreset: {...state.selectedPreset, [property]: action.payload.value}}
    case actionTypes.PRICING_PRESET_LOAD:
      newState.selectedPreset.data = [...action.payload.data];
      break;
    case actionTypes.PRICING_PRESET_SELECT_STONE:
      if(newState.selected[action.payload.key]) {
        delete newState.selected[action.payload.key];
      } else {
        newState.selected[action.payload.key] = action.payload.value;
      }
      break;
    case actionTypes.PRICING_PRESET_SET_SELECTED_STONES:
      newState.selected = {...action.payload.selected};
      break;
    case actionTypes.PRICING_PRESET_DELETE:
      const index = newState.presets.findIndex(p => p.id == newState.selectedPreset.id);
      if (index >= 0) {
        newState.presets.splice(index, 1);
        newState.selectedPreset = {...initialState.selectedPreset};
      }
      break;
    case actionTypes.PRICING_PRESET_SET_APPLY_TO_PRICE:
    case actionTypes.PRICING_PRESET_SET_PRESETS_RECEIVED:
      return {...newState, ...action.payload}
  }

  return {...newState};
}


let nameSort = (a, b) => {
  let as = a.name.split('-'),
    bs = b.name.split('-'),
    aName = as[as.length - 1].trim().toLowerCase(),
    bName = bs[bs.length - 1].trim().toLowerCase();
  if(aName < bName) {
    return -1;
  } else if(aName > bName) {
    return 1;
  }
  return 0;
}

let selectedSort = (selected) => {
  let sortable = [];
  for(var stoneId in selected) {
    sortable.push(selected[stoneId]);
  }
  sortable.sort(nameSort);
  return sortable;
}
